export default __webpack_public_path__ + "static/media/smallWhiteLogoAcium.56de22d5.svg";